// extracted by css-extract-rspack-plugin
export default {"footer":"Lg2Mb","links":"wWW48","link":"rYeQV"};